export default function validarDataValidadeCartao(valor: string) {
  if (!/^\d{2}\/\d{4}$/.test(valor)) return false;

  const [mes, ano] = valor.split('/').map(Number);
  if (mes < 1 || mes > 12) return false;

  const dataAtual = new Date();
  const anoAtual = dataAtual.getFullYear();
  const mesAtual = dataAtual.getMonth() + 1;

  if (ano < anoAtual || (ano === anoAtual && mes < mesAtual)) {
    return false;
  }

  return true;
}
